import useLabels from "hooks/useLabels";
import { LargeHumanTrialIcon } from "design_system";

/**
 * @component LargeHumanTrialTooltip
 * @description Tooltip for large human trial
 * @example
 * return (
 *   <LargeHumanTrialTooltip />
 * )
 */

const LargeHumanTrialTooltip = () => {
  const [pageLabels] = useLabels("tooltips.large-human-trial");
  return (
    <div className="flex flex-col gap-3">
      <p className="flex items-center gap-3 sm-bold text-fg-base">
        <LargeHumanTrialIcon size="lg" />
        {pageLabels.title}
      </p>
      <div className="flex flex-col space-y-2 sm-normal">
        <p className="text-fg-base">{pageLabels.content[0]}</p>
        <div>
          <div className="flex items-center gap-3">
            <i className="icon-check text-chart-green-base text-xl" />
            <p className="text-fg-muted">{pageLabels.content[1]}</p>
          </div>
          <div className="flex items-center gap-3">
            <i className="icon-check text-chart-green-base text-xl" />
            <p className="text-fg-muted">{pageLabels.content[2]}</p>
          </div>
          <div className="flex items-center gap-3">
            <i className="icon-check text-chart-green-base text-xl" />
            <p className="text-fg-muted">{pageLabels.content[3]}</p>
          </div>
        </div>
      </div>
      <p className="text-fg-base">{pageLabels.content[4]}</p>
    </div>
  );
};

export default LargeHumanTrialTooltip;
